<h4>Select a pick-up method</h4>

<div *ngFor='let pickupType of pickupOptions'>
  <img alt="pickup icon" class="pickupclass" src="{{pickupType.pickupImage}}">
  <a role="button" (click)="selectPickuptype(pickupType.pickupTypeId)">{{pickupType.pickupType}}</a>
  <br>
</div>
<h4>Cancel</h4>
